export default "<p>cathegories works!</p>\r\n"